/**
 * This reducer contains data related to routing, like redirect URL
 * updateRedirectionData: This is for preserving data or sharing data within redirection
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  redirectTo: null,
  navigateState: {},
  redirectionData: null,
};

const routingSlice = createSlice({
  name: 'routing',
  initialState,
  reducers: {
    updateRedirectTo: (state, { payload }) => ({ ...state, redirectTo: payload }),
    updateNavigateState: (state, { payload }) => ({ ...state, navigateState: payload }),
    updateRedirectionData: (state, { payload }) => ({ ...state, redirectionData: payload }),
    resetRouting: (state) => {
      state.redirectTo = initialState.redirectTo;
    },
  },
});

export const {
  updateRedirectTo, updateRedirectionData, updateNavigateState, resetRouting,
} = routingSlice.actions;

export default routingSlice.reducer;
